import { render } from "./HeaderMilesforhumanity.vue?vue&type=template&id=10d948df&scoped=true"
import script from "./HeaderMilesforhumanity.vue?vue&type=script&lang=js"
export * from "./HeaderMilesforhumanity.vue?vue&type=script&lang=js"

import "./HeaderMilesforhumanity.vue?vue&type=style&index=0&id=10d948df&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d948df"]])

export default __exports__